const HOST_KEY = "b2c_host_url";

export const isEmbedded = (): boolean => window.self !== window.top;

/**
 * Resolves the full host URL from document.referrer.
 * Returns null if referrer is empty, same-origin as the widget, or unparseable.
 */
export const resolveHostUrl = (): string | null => {
  const referrer = document.referrer;
  if (!referrer) return null;

  try {
    const refUrl = new URL(referrer);
    if (refUrl.origin === window.location.origin) return null; // referrer is the widget itself
    return refUrl.href; // Retains full URL (origin + pathname + query params)
  } catch {
    return null;
  }
};

export const captureHostUrl = (): void => {
  const urlParams = new URLSearchParams(window.location.search);
  const hostUrlParam = urlParams.get("hostUrl") || urlParams.get("b2cHostUrl") || urlParams.get("returnUrl");
  
  if (hostUrlParam) {
    sessionStorage.setItem(HOST_KEY, hostUrlParam);
    return;
  }

  if (!isEmbedded()) {
    sessionStorage.removeItem(HOST_KEY);
    return;
  }

  const resolved = resolveHostUrl();
  if (resolved) {
    sessionStorage.setItem(HOST_KEY, resolved);
  } else {
    sessionStorage.removeItem(HOST_KEY);
  }
};

export const getHostUrl = (): string | null => {
  const stored = sessionStorage.getItem(HOST_KEY);
  if (!stored || stored === "null") return null;
  if (stored === window.location.origin) return null;
  return stored;
};

export const redirectHome = (navigate?: (path: string) => void): void => {
  const hostUrl = getHostUrl();
  if (isEmbedded() && hostUrl) {
    try {
      (window.top as Window).location.href = hostUrl;
      return;
    } catch {
      // sandboxed iframe without top-nav permission — fall through
    }
  }
  if (navigate) navigate("/");
  else window.location.assign("/");
};